import { useTranslation } from '@multaqa/i18n'
import { Button } from '@multaqa/ui/components/ui/button'
import { AdminScreen } from '@/components/admin-screen'
import { InlineQueryError } from '@/components/inline-query-error'

export function CompanyNotFound({ groupId, groupName }: { groupId: string; groupName: string }) {
  const { t } = useTranslation()
  const trail: { label: string; href: string }[] = [
    { label: t('rail.admin.sections.customers'), href: '/groups' },
    { label: groupName, href: `/groups/${groupId}` },
  ]
  return (
    <AdminScreen
      // AdminScreen's `trail` type is `string[]`; PageHeader (what it forwards
      // to) accepts a linked crumb too, and the linked form is what this
      // screen has always shown.
      trail={trail as unknown as string[]}
      title={t('companies.notFound.title')}
      description={t('companies.notFound.body')}
      testId="company-detail-not-found"
    >
      <Button asChild variant="outline">
        <a href={`/groups/${groupId}`}>{t('companies.notFound.back')}</a>
      </Button>
    </AdminScreen>
  )
}

export function CompanyDataError({ retry }: { retry: () => void }) {
  const { t } = useTranslation()
  return (
    <InlineQueryError
      title={t('companies.detail.loadFailed.title')}
      description={t('companies.detail.loadFailed.body')}
      retryLabel={t('action.retry')}
      onRetry={retry}
    />
  )
}
